export default function Proof() {
  return (
    <section data-testid="proof-section" className="py-24 px-6 lg:px-12 max-w-7xl mx-auto">
      <div className="border border-[#24283b] bg-[#101420] p-8 md:p-12 relative overflow-hidden">
        <div className="grid grid-cols-1 md:grid-cols-2 gap-8 items-center">
          <div>
            <span className="font-mono-goat text-xs uppercase tracking-widest text-[#45f3ff]">
              Early Founder Feedback
            </span>
            <h3 className="font-display text-3xl uppercase tracking-tight text-white mt-2">
              Verified Production Records
            </h3>
            <div
              data-testid="proof-empty-state"
              className="mt-6 p-6 border border-dashed border-[#24283b] bg-[#0c0f18]"
            >
              <p className="font-mono-goat text-xs text-neutral-400">
                [ Verified partner reviews and case studies from our inaugural production cohort are
                being indexed for publication. ]
              </p>
            </div>
          </div>
          <div className="space-y-4">
            <div className="border-l-2 border-[#45f3ff] pl-4">
              <h4 className="font-display text-xl uppercase text-white">Startup Ready</h4>
              <p className="text-neutral-400 text-xs">
                Rapid sprint pipelines designed for early ventures launching on strict timelines.
              </p>
            </div>
            <div className="border-l-2 border-[#6c72cb] pl-4">
              <h4 className="font-display text-xl uppercase text-white">Turnkey Assurance</h4>
              <p className="text-neutral-400 text-xs">
                Physical manufactured assets match digital brand geometry without distortion.
              </p>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
